import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Divider } from '@mui/material';
import VehiclesGrid from '../modules/VehiclesGrid';
import Page from '../components/Page/Page';
import Breadcrumbs from '../components/BreadCrumbs/BreadCrumbs';
import { PATHS } from '../utils/constants';
import { FolderTabs } from '../components';
import InventoryGrid from '../modules/InventoryGrid';

const Vehicles = () => {
  const navigate = useNavigate();
  // constants
  const links = [
    {
      label: 'Dashboard',
      link: PATHS.dashboard,
    },
    {
      label: 'Vehicles',
      link: PATHS.vehicles,
    },
  ];

  return (
    <Page sx={{ p: 0.5 }}>
      <Breadcrumbs links={links} />
      <Divider sx={{ mt: 0.5 }} />

      <FolderTabs
        tabItems={[
          {
            label: 'Vehicles',
            // onClick() {
            //   getInventory();
            // },
            content: <VehiclesGrid />,
          },
          {
            label: 'Inventory',
            onClick() {
              navigate('/v360-app/inventory');
            },
            content: <InventoryGrid />,
          },
        ]}
      />
    </Page>
  );
};

export default Vehicles;
